var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 82,
    height: 131,
    viewBox: "0 0 82 131",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "arrow-upload-a",
    d: "M46,17.0710678 L46,126 C46,128.761424 43.7614237,131 41,131 C38.2385763,131 36,128.761424 36,126 L36,17.0685425 L9.10660172,43.9619408 C7.15398026,45.9145622 3.98815536,45.9145622 2.03553391,43.9619408 C0.0829124472,42.0093193 0.0829124472,38.8434944 2.03553391,36.890873 L37.390873,1.53553391 C37.4240362,1.50237068 37.4575494,1.46977069 37.4914006,1.43773394 C38.3940144,0.548634153 39.632937,2.51125399e-16 41,0 C42.3987201,-2.56940713e-16 43.6632964,0.574337813 44.5707613,1.50004576 C44.5827528,1.5118026 44.5946998,1.52363198 44.6066017,1.53553391 L79.9619408,36.890873 C81.9145622,38.8434944 81.9145622,42.0093193 79.9619408,43.9619408 C78.0093193,45.9145622 74.8434944,45.9145622 72.890873,43.9619408 L46,17.0710678 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "arrow-upload-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#arrow-upload-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#007FAD",
    xlinkHref: "#arrow-upload-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#006C94",
    points: "98 -54 98 186 -27 186",
    mask: "url(#arrow-upload-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpload);
export default __webpack_public_path__ + "static/media/arrow-upload.e6de7bc88ba5d769bd27aaaf11947843.svg";
export { ForwardRef as ReactComponent };